/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';

export interface AuthState {
    userId?: string;
}

export const useAuthState = () => {
    const authState = useSelector((state: RootState | any) => state.auth as AuthState);
    return authState;
}

export const useIsAuthenticated = () => {
    return !!useAuthState().userId;
}

// Define the initial state using that type
const initialState: AuthState = {
    userId: undefined,
}

export const authSlice = createSlice({
    name: 'auth',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        signIn: (state, action: PayloadAction<string | undefined>) => {
            return {
                ...state,
                userId: action.payload
            }
        },
        signOut: state => {
            return {
                ...state,
                userId: undefined
            }
        },
    }
})

export const { signIn, signOut } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
//export const getUser = (state: RootState) => state

export default authSlice.reducer;